import { useQuery } from "@tanstack/react-query";
import { Workflow } from "lucide-react";
import { useTranslation } from "react-i18next";
import { listFlowsOptions } from "@/api";
import { Page } from "@/components/Page";
import { spaceWorkflowPath } from "@/features/build/workflows/flowRunPaths";
import { SpaceItemsList } from "./SpaceItemsList";
import { useSettingsSpace } from "./useSpaceSettings";

/** Workflows in the space: keep them private or share them; the space page shows each with its last run. */
export function WorkflowsSection() {
  const { t } = useTranslation("spaces", { keyPrefix: "settings.workflows" });
  const space = useSettingsSpace();
  const flows = useQuery({
    ...listFlowsOptions({ query: { page_size: 100 } }),
    select: (r) => r.data.map((f) => ({ uuid: f.uuid, name: f.name, description: f.description })),
  });
  return (
    <Page title={t("title")}>
      <SpaceItemsList
        spaceUuid={space.uuid}
        type="flow"
        title={t("title")}
        addLabel={t("add")}
        addTitle={t("addTitle")}
        emptyHint={t("empty")}
        icon={<Workflow size={18} />}
        openPath={(uuid) => spaceWorkflowPath(space.uuid, uuid)}
        options={flows}
        showTitle={false}
      />
    </Page>
  );
}
